import { defineComponent as t, openBlock as r, createBlock as a, unref as c, mergeProps as d, withCtx as h, createElementVNode as e } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const i = /* @__PURE__ */ t({
  name: "IconReassuranceShield24Months",
  __name: "IconReassuranceShield24Months",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (p, l) => (r(), a(c(v), d(o, { "view-box": "0 0 48 48" }), {
      default: h(() => [...l[0] || (l[0] = [
        e("path", { d: "M29.55 21.31V16.7l-3.29 4.61h3.29" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M10 24.67V8h28v16.64c0 8.03-8.19 12.91-14 15.36-6.7-2.79-14-7.62-14-15.33m5.11.73h7.74v-1.89H18.1l2.87-2.72a4.93 4.93 0 0 0 1.85-3.44c0-1.87-1.52-3.2-3.82-3.2-2.59 0-4 1.39-4 3.74h2.22c0-1.31.71-2 1.71-2a1.45 1.45 0 0 1 1.59 1.45 3 3 0 0 1-1.12 2.12l-4.29 4.11v1.83m16.61-2.31h1.36v-1.77h-1.36v-7h-2.6l-5.06 6.95v1.85h5.5v2.28h2.16v-2.31",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M46 0H2v24.38C2 36.48 12.81 44.08 24 48c11.15-3.88 22-11.55 22-23.65V0m-4 4v20.38c0 11-11.69 17-18 19.39C8.38 37.83 6 29.12 6 24.38V4h36",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  i as default
};
